var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('main-navbar',{on:{"toggle":_vm.toggle}}),_c('mobile-navbar',{attrs:{"show":_vm.showMenu},on:{"toggle":_vm.toggle}}),_c('div',{staticClass:"main__content"},[_c('router-view')],1),_c('main-footer'),_c('scroll-top-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }